import React from 'react';
import { DetailInfo } from './DetailInfo';
import { Form } from './Form';
import { Location } from './Location';
import { MoreInfo } from './MoreInfo';
import { PDFButton } from '../PDFButton';
import { getInfoData, L } from 'src/Utils';
import { useWindowWidth } from 'src/useWindowWidth';
import { Container, InfoContainer } from './styles';
import { Divider } from '../styles';
export var BottomInfo = function (_a) {
    var info = _a.info;
    var windowWidth = useWindowWidth();
    var moreInfoData = getInfoData(info.property_type, info, false);
    return (React.createElement(Container, null,
        React.createElement(InfoContainer, null,
            React.createElement(MoreInfo, { data: moreInfoData }),
            React.createElement(DetailInfo, { cod: info.code, description: info.description, price: info.price, currency: info.currency }),
            React.createElement(Divider, null),
            React.createElement(Location, { description: info.location_description, coords: { lat: Number(info.latitude), lng: Number(info.longitude) } }),
            windowWidth < L && React.createElement(PDFButton, { info: info }),
            windowWidth < L && (React.createElement(Form, { currency: info.currency, price: info.price, propertyType: info.property_type, size: info.square_meters, operationType: info.operation_type, propertyId: info.id }))),
        windowWidth > L && (React.createElement(Form, { currency: info.currency, price: info.price, propertyType: info.property_type, size: info.square_meters, operationType: info.operation_type, propertyId: info.id }))));
};
